import { CARD_TYPES } from "../../Card/constants";
import DisplayPolicy from "./DisplayPolicy";
import { DEFAULT_MAP_KEY } from "../constants";

/**
 * @class FeaturedPolicy
 * @extends DisplayPolicy
 */
class FeaturedPolicy extends DisplayPolicy {
    constructor(props) {
        super();
        this.policyName = "FeaturedPolicy";
        this.viewport = props.viewport;
        this.hasTopStories = props.hasTopStories;
        this.richPolicy = props.richPolicy ? props.richPolicy : false;
        this.contentPackage = props.contentPackage
            ? props.contentPackage
            : null;
    }

    buildCardTypesMap(listLength) {
        this.cardTypesMap = new Map();
        const IDX_0 = 0;
        const IDX_1 = 1;
        const IDX_3 = 3;
        const IDX_4 = 4;

        // In medium and large viewports, the Top and Highlighted stories appear
        let highlightedStoriesNum = IDX_3;
        let topStoriesNum = this.richPolicy ? IDX_1 : IDX_4;
        let startIndex = this.hasTopStories ? topStoriesNum : IDX_0;

        // In small viewport, there's only one FULL_BLEED card and the rest are default,
        // without special treatment for Top and Highlighted stories
        if (this.viewport === "viewportSmall") {
            highlightedStoriesNum = IDX_1;
            startIndex = IDX_0;
        }

        for (let index = 0; index < listLength; index++) {
            let currentCardType = CARD_TYPES.TYPE_DEFAULT;

            if (this.hasTopStories && index === IDX_0) {
                currentCardType = currentCardType =
                    this.richPolicy && !this.contentPackage
                        ? CARD_TYPES.TYPE_FEATURED
                        : CARD_TYPES.TYPE_FEATURED_AUTHOR;
            } else if (
                index >= startIndex &&
                index < startIndex + highlightedStoriesNum
            ) {
                currentCardType = CARD_TYPES.TYPE_LISTING_AUTHOR;
            } else {
                currentCardType = this.richPolicy
                    ? CARD_TYPES.TYPE_REGULAR
                    : CARD_TYPES.TYPE_DEFAULT;
            }
            this.cardTypesMap.set(index, currentCardType);
        }

        this.cardTypesMap.set(DEFAULT_MAP_KEY, CARD_TYPES.TYPE_DEFAULT);
    }
}

export default FeaturedPolicy;
